/**
 * @Author: Zewei
 * @Date:   2018-01-22T19:02:31+08:00
 * @Last modified by:   Zewei
 * @Last modified time: 2018-01-23T19:53:58+08:00
 */
import keyMirror from "keymirror";

export const SystemSettingConstants = {
  ActionTypes: keyMirror({
    FETCHDATA: null,
    FETCHSUCCESS: null,
    FETCHFAILURE: null,
    CREATEROLESUCCESS: null,
    CREATEROLEFAILURE: null,
    DELETEROLESSUCCESS: null,
    DELETEROLESFAILURE: null,
    HIDDENMODAL: null,

    INITSYSTEMLOGGER: null,
    FETCHSYSTEMLOGGERSUCCESS: null,
    FETCHSYSTEMLOGGERFAILURE: null,

    INITSYSTEMLOGGERSETTING: null,
    FETCHSYSTEMLOGGERSETTINGSUCCESS: null,
    FETCHSYSTEMLOGGERSETTINGFAILURE: null,
    
    ADDSYSTEMLOGGERSETTINGSUCCESS: null,
    ADDSYSTEMLOGGERSETTINGFAILURE: null,
    SAVESYSTEMLOGGERSETTINGSUCCESS: null,
    SAVESYSTEMLOGGERSETTINGFAILURE: null,

    FETCHSYSTEMMODULESUCCESS: null,
    FETCHSYSTEMMODULEFAILURE: null,

    DELETEUSERSSUCCESS: null,
    DELETEUSERSFAILURE: null,
    INACTIVEUSERSUCCESS: null,
    INACTIVEUSERFAILURE: null,

    UPDATEUSERSUCCESS:  null,
    UPDATEUSERFAILURE: null,
    HANDLEAUTHORIZESUCCESS:null,
  })
};



// WEBPACK FOOTER //
// ./src/constants/system-setting-constants.js